module.exports = {
  "container": {
    "position": "absolute",
    "top": "0",
    "left": "0"
  },
  "mask": {
    "top": 0,
    "width": "750",
    "height": "1344",
    "alignItems": "center",
    "backgroundColor": "#1E2E37",
    "opacity": 0.3,
    "position": "fixed"
  },
  "operate-box": {
    "backgroundColor": "rgba(255,255,255,0.9)",
    "width": "540",
    "borderRadius": "26",
    "position": "fixed",
    "left": "105"
  },
  "box-title-wrapper": {
    "paddingTop": "30",
    "paddingBottom": "20"
  },
  "box-title-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontWeight": "bold",
    "fontSize": "32",
    "color": "#1E2E37",
    "textAlign": "center"
  },
  "box-input-wrapper": {
    "paddingLeft": "32",
    "paddingRight": "32",
    "paddingTop": "10",
    "paddingBottom": "24"
  },
  "box-input": {
    "borderWidth": "1",
    "borderStyle": "solid",
    "borderColor": "#9F9F9F",
    "color": "#1E2E37",
    "backgroundColor": "#FFFFFF",
    "height": "48",
    "fontSize": "24",
    "paddingLeft": "8"
  },
  "box-btn-group": {
    "flexDirection": "row",
    "borderTopStyle": "solid",
    "borderTopWidth": "1",
    "borderTopColor": "#e5e5e5",
    "height": "84",
    "overflowX": "hidden",
    "overflowY": "hidden"
  },
  "box-btn-wrapper": {
    "flexDirection": "row",
    "height": "84",
    "flex": 1,
    "alignItems": "center",
    "justifyContent": "center"
  },
  "btn-border-r": {
    "borderRightStyle": "solid",
    "borderRightWidth": "1",
    "borderRightColor": "#e5e5e5"
  },
  "box-btn-text": {
    "textAlign": "center",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32"
  },
  "cancel-text": {
    "fontWeight": "bold"
  },
  "confirm-text": {
    "color": "#1E2E37"
  },
  "wrapper": {
    "backgroundColor": "#F7F7F7",
    "position": "relative"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-30dfad71!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-promt/index.vue
// module id = 460
// module chunks = 0 1